'use client';

import { createContext, type ReactNode, useContext } from 'react';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';

import { mainPageConfig } from './config';
import type { MainPageConfig } from './types';

const MainPageConfigContext = createContext<MainPageConfig | null>(null);

interface Props {
  children: ReactNode;
}

export function MainPageConfigProvider({ children }: Props) {
  const { teamSlug } = useTeamConfig();
  const pageConfig = mainPageConfig[teamSlug];

  return <MainPageConfigContext.Provider value={pageConfig}>{children}</MainPageConfigContext.Provider>;
}

export function useMainPageConfig() {
  const context = useContext(MainPageConfigContext);

  if (!context) {
    throw new Error('useMainPageConfig must be used within MainPageConfigProvider');
  }

  return context;
}
